import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { APARTMENT_MODULE_NAMESPACE, APARTMENT_GET_APPARTMENTS, APARTMENT_GET_SIDEBAR_APPARTMENTS } from '../../../../store/apartment';
import { IApartmentListingViewModel, IApartmentParameter } from '../../../../models/apartment';

const ApartmentStore = namespace(APARTMENT_MODULE_NAMESPACE)
@Component
class BlockSidebarWidgetApartments extends Vue {

  @ApartmentStore.Getter sidebarApartments: IApartmentListingViewModel[];
  @ApartmentStore.Action(APARTMENT_GET_SIDEBAR_APPARTMENTS)
  storeGetApartments: (blockId: string) => Promise<IApartmentListingViewModel[]>;


  @Prop({ default: null, type: [String] })
  path: string;


  get coApartments() {
    return this.sidebarApartments;
  }
  isActive(id: number) {
    if (id.toString() === this.$route.params.cid)
      return 'turquoise';
    return ''
  }
  isActiveText(id: number) {
    if (id.toString() === this.$route.params.cid)
      return 'primary--text';
    return 'white--text'
  }
  redirectTo(apartment: { apartment_number: string, id: number }) {
    return {
      path: `/block/${this.$route.params.id}/apartment/${apartment.id}`,
      params: { id: this.$route.params.id, cid: apartment.id },
      query: {
        name: apartment.apartment_number,
      }
    }
  }

  mounted() {
    this.storeGetApartments(this.$route.params.id)
    this.$watch('$route.params', (n, o) => this.storeGetApartments(n.id));
  }

}

export default BlockSidebarWidgetApartments;


// WEBPACK FOOTER //
// ./src/containers/block/components/block-sidebar-widget-apartments/index.ts